import { useEffect, useRef } from 'react';
import { baseApi } from '@/shared/api';

export function useCrossTabAuthReload() {
  const observedUserId = useRef<string | null | undefined>(undefined);

  useEffect(() => {
    const { data } = baseApi.auth.onAuthStateChange((_event, session) => {
      const previousUserId = observedUserId.current;
      const currentUserId = session?.user.id ?? null;
      const isFirstObservation = previousUserId === undefined;

      if (isFirstObservation || previousUserId === currentUserId) {
        observedUserId.current = currentUserId;

        return;
      }

      if (globalThis.document.hidden) {
        observedUserId.current = currentUserId;
        globalThis.location.reload();
      }
    });

    return () => {
      data.subscription.unsubscribe();
    };
  }, []);
}
